$(function() {
  
 

 /*
  document.addEventListener('product:added', function(event) {
    console.log('aaa');
		$('.Cart__Checkout').hide();
    setTimeout( function () { 
        		$('.Cart__Checkout').hide();

    }, 4000);
  });
  
  $(document).on('click','button',  function() {
    event.preventDefault;
        console.log("clicked...waiting...");

        setTimeout(
            function() {
                alert("Called after delay.");
            },
            5000);
    });
 */
  
}); 